import React from 'react';
import styled from 'styled-components';

import { Chip } from 'common/components/Chip';
import { useIsOfflineHourEnabled } from 'modules/insights-v2/hooks/useIsOfflineHourEnabled';
import { InsightEntity } from 'modules/insights-v2/types';

import { OfflineInterval } from './types';

type OfflineIntervalSelectorProps = {
  insightEntityType: InsightEntity['type'];
  offlineInterval: OfflineInterval;
  onChange: (offlineInterval: OfflineInterval) => void;
};

const ChartOfflineIntervalSelector = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const OfflineIntervalSelector = ({ insightEntityType, offlineInterval, onChange }: OfflineIntervalSelectorProps) => {
  const { isLoading, isOfflineHourEnabled } = useIsOfflineHourEnabled(insightEntityType);

  return !isLoading && isOfflineHourEnabled ? (
    <ChartOfflineIntervalSelector>
      <Chip
        label="Per day"
        isActive={offlineInterval === OfflineInterval.DAY}
        onClick={() => onChange(OfflineInterval.DAY)}
      ></Chip>
      <Chip
        label="Per hour"
        isActive={offlineInterval === OfflineInterval.HOUR}
        onClick={() => onChange(OfflineInterval.HOUR)}
      ></Chip>
    </ChartOfflineIntervalSelector>
  ) : (
    <></>
  );
};

export default OfflineIntervalSelector;
